import React, { useEffect, useState } from 'react';
import { fetchAllSessionMedium } from '../../api/analyticsApi';
import { Box, Typography, Divider, Dialog, DialogTitle, DialogContent, IconButton, Select, MenuItem } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const SessionMediumChart = () => {
  const [data, setData] = useState([]);
  const [open, setOpen] = useState(false);
  const [fullData, setFullData] = useState([]);
  const [period, setPeriod] = useState(() => localStorage.getItem('analyticsPeriod') || '7d');

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user'));
    const propertyId = user?.propertyId?.id;

    if (!propertyId) return;

    fetchAllSessionMedium(propertyId, period)
      .then((res) => {
        setData(res);
      })
      .catch((err) => {
        console.error("Failed to fetch session medium", err);
      });
  }, [period]);

  const getDateRangeText = () => {
    const end = new Date();
    const start = new Date();
    const days = parseInt(period.replace('d', ''), 10);
    start.setDate(end.getDate() - days + 1);
    const options = { month: 'short', day: 'numeric' };
    return `${start.toLocaleDateString(undefined, options)} – ${end.toLocaleDateString(undefined, options)}`;
  };

  return (
    <Box
      p={2}
      bgcolor="white"
      borderRadius={2}
      boxShadow={1}
      sx={{ maxWidth: 890, maxHeight: 800, overflow: 'hidden' }}
    >
      <Typography variant="subtitle2" color="textSecondary" gutterBottom>
        SESSION MEDIUM
      </Typography>

      <Box maxHeight={400} overflow="auto" pr={1}>
        {data.map((item, index) => (
          <Box key={index} mb={1}>
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Typography variant="body2">{item.medium}</Typography>
              <Typography
                variant="body2"
                sx={{ fontFamily: 'monospace', minWidth: 48, textAlign: 'right' }}
              >
                {item.count.toLocaleString()}
              </Typography>
            </Box>
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Box flex={1} height={6} bgcolor="#e0e0e0" borderRadius={4} mr={1}>
                <Box
                  height="100%"
                  width={`${Math.min(item.count / data[0].count * 100, 100)}%`}
                  bgcolor="#1976d2"
                  borderRadius={4}
                />
              </Box>
              <Typography variant="caption" color={item.change >= 0 ? 'green' : 'error'}>
                {item.change >= 0 ? '▲' : '▼'} {Math.abs(item.change)}%
              </Typography>
            </Box>
          </Box>
        ))}
      </Box>

      <Divider sx={{ my: 2 }} />

      <Box display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap" gap={2}>
        <Box flex={1}>
          <Select
            value={period}
            onChange={(e) => {
              const value = e.target.value;
              setPeriod(value);
              localStorage.setItem('analyticsPeriod', value);
            }}
            variant="standard"
            disableUnderline
            sx={{ fontSize: 14 }}
          >
            <MenuItem value="7d">Last 7 days</MenuItem>
            <MenuItem value="30d">Last 30 days</MenuItem>
            <MenuItem value="60d">Last 60 days</MenuItem>
            <MenuItem value="90d">Last 90 days</MenuItem>
          </Select>
        </Box>
        <Box flex={1} textAlign="center">
          <Typography variant="caption" color="textSecondary">
            {getDateRangeText()}
          </Typography>
        </Box>
        <Box flex={1} textAlign="right">
          <Typography
            variant="body2"
            color="primary"
            sx={{ cursor: 'pointer' }}
            onClick={() => {
              const user = JSON.parse(localStorage.getItem('user'));
              const propertyId = user?.propertyId?.id;
              if (!propertyId) return;
              fetchAllSessionMedium(propertyId, period).then(setFullData);
              setOpen(true);
            }}
          >
            View traffic acquisition →
          </Typography>
        </Box>
      </Box>
      <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth="sm">
        <DialogTitle>
          All Traffic Sources
          <IconButton
            aria-label="close"
            onClick={() => setOpen(false)}
            sx={{ position: 'absolute', right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          {fullData.map((item, idx) => (
            <Box key={idx} display="flex" justifyContent="space-between" py={1}>
              <Typography variant="body2">{item.medium}</Typography>
              <Typography
                variant="body2"
                sx={{ fontFamily: 'monospace', minWidth: 48, textAlign: 'right' }}
              >
                {item.count.toLocaleString()}
              </Typography>
            </Box>
          ))}
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default SessionMediumChart;
